import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { InstallHelp } from "./InstallAppButton";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallBanner = () => {
  const [prompt, setPrompt] = useState(typeof window !== "undefined" ? window.__deferredInstallPrompt : null);
  const [installed, setInstalled] = useState(isStandalone());
  const [help, setHelp] = useState(false);
  const [apk, setApk] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const onAvail = () => setPrompt(window.__deferredInstallPrompt);
    const onInstalled = () => setInstalled(true);
    window.addEventListener("pwa-installable", onAvail);
    window.addEventListener("pwa-installed", onInstalled);
    if (/android/i.test(navigator.userAgent)) api.get("/apk/info").then((r) => setApk(!!(r.data?.available || r.data?.external_url))).catch(() => {});
    return () => {
      window.removeEventListener("pwa-installable", onAvail);
      window.removeEventListener("pwa-installed", onInstalled);
    };
  }, []);

  // Only hide once the app is actually installed — no manual dismiss (permanent). No native prompt (iPhone etc.) → step-by-step help.
  if (installed) return null;

  const install = async () => {
    if (prompt) {
      prompt.prompt();
      const res = await prompt.userChoice;
      if (res && res.outcome === "accepted") setInstalled(true);
      window.__deferredInstallPrompt = null;
      setPrompt(null);
    } else {
      setHelp(true);
    }
  };

  return (
    <div className="rl-card p-3 flex items-center gap-3 rl-fade-up" data-testid="install-banner"
      style={{ background: "linear-gradient(120deg,#EFF6FF,#DBEAFE)" }}>
      <div className="w-10 h-10 rounded-xl rl-gold-bg flex items-center justify-center shrink-0"><Download className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-slate-900 text-sm">Install ROYAL LAKSHMI</div>
        <div className="text-[11px] text-slate-500 truncate">Add to home screen for faster access & alerts</div>
      </div>
      <div className="flex flex-col gap-1 shrink-0">
        <button onClick={install} className="rl-gold-bg text-sm font-bold px-4 py-2 rounded-xl" data-testid="install-banner-btn">Install</button>
        {apk && <button onClick={() => nav("/app")} className="text-[11px] font-black text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-1 rounded-lg" data-testid="install-banner-apk">APK ↓</button>}
      </div>
      {help && <InstallHelp onClose={() => setHelp(false)} />}
    </div>
  );
};
